import { Controller } from 'stimulus';

// Shows the parts of a field form that apply to the chosen field type: each
// section target lists its types in data-types ("dropdown multi_select").
// On submit, the inputs in hidden sections are blanked, so a field changed
// from Dropdown to Text doesn't keep its options.
export default class extends Controller {
  static targets = ['type', 'section'];

  connect() {
    this.change();
  }

  change() {
    const type = this.typeTarget.value;
    this.sectionTargets.forEach((section) => {
      section.hidden = !section.dataset.types.split(' ').includes(type);
    });
  }

  clean() {
    this.sectionTargets.filter((section) => section.hidden).forEach((section) => {
      section.querySelectorAll('input[name]').forEach((input) => { input.value = ''; });
    });
  }
}
